export class ValidatorsHelper {

	private static phoneRegex = /^\d+$/;
	private static emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	public static validCommaSeparatedPattern = /^(?!,)(?!.*,,)(?!.*\n).+$/;

    public static patternForAlphaNumeric = /[^a-zA-Z0-9]/;
    public static NoLeadingSpace = /^(?!\s).+/;
	public static readonly URL_REGEX = /^(https?:\/\/)(www\.)?([a-zA-Z0-9.-]+)\.([a-z]{2,6})(\/.*)?$/;


	public static validatePassword(passwordString?: string): Array<ValidatorModel> {
		const validatorObject: Array<ValidatorModel> = this.getPasswordValidators();
		if (!passwordString) {
			return validatorObject;
		}

		// tslint:disable-next-line:prefer-for-of
		for (let i = 0; i < validatorObject.length; i++) {
			const validator = validatorObject[i];
			validatorObject[i].passed = !!passwordString.match(validator.regex);
		}
		return validatorObject;
	}

	public static getPasswordValidators(): Array<ValidatorModel> {
		return [
			{id: 1, title: 'A Lowercase letter (a)', passed: false, regex: '(?=.*[a-z])'},
			{id: 1, title: 'An Uppercase letter (A)', passed: false, regex: '^(?=.*?[A-Z])'},
			{id: 2, title: 'A special character (!@#) ', passed: false, regex: '(?=.*[!@#\$%\^&_])'},
			{id: 3, title: 'A number (1)', passed: false, regex: '(?=.*?[0-9])'},
			{id: 4, title: '8 Characters Minimum', passed: false, regex: '.{8,}'}
		];
	}

	public static isEmailValid(email: string): boolean {
		return !!email && this.emailRegex.test(email);
	}

	public static isPhoneNumberValid(phone: string) {
		return !!phone && this.phoneRegex.test(phone);
	}
}

export class ValidatorModel {
	id: number;
	title: string;
	passed: boolean;
	regex: string;
}
